import React from "react";
import { Label, FormGroup } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faEdit } from "@fortawesome/free-solid-svg-icons";
import IInput from "../iInput/IInput";
import ITypeSelectProps from "./ITypeSelect.props";
import ITypeSelectState from "./ITypeSelect.state";
import { Styled } from "../../decorators/Artifact";
import s from "./styles.scss";

@Styled(s)
export default class ITypeSelect extends IInput<
  ITypeSelectProps,
  ITypeSelectState
> {
  state = {
    value: "",
    options: [],
    selected: null,
    isExpanded: false
  };

  componentDidMount(): void {
    if (this.props.init) {
      this.setState(
        {
          value: this.props.init
        },
        () => super.triggerInput()
      );
    } else {
      super.triggerInput();
    }

    this.mapOptions();
  }

  componentDidUpdate(prevProps): void {
    if (this.props.init != prevProps.init) {
      const selected = this.state.options.find(o => o.value == this.props.init);
      this.setState({
        value: this.props.init,
        selected: selected ? [selected] : null
      });
    }

    if (this.props.data != prevProps.data) {
      this.mapOptions();
    }
  }

  onChange = selected => {
    const value = selected && selected.length ? selected[0].value : "";
    this.props.setter && this.props.setter(this.props.name, value);
    this.props.onChange && this.props.onChange(value);
    this.setState({ value, selected });
  };

  mapOptions() {
    const data = (this.props.data && this.props.data) || [];
    const options = this.props.mapOption
      ? data.map(this.props.mapOption)
      : data;
    const selected = options.find(o => o.value == this.state.value);
    this.setState({ options, selected: selected ? [selected] : null });
  }

  toggleExpanded = () => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onExpandRow) {
      this.props.onExpandRow();
    }

    this.setState({ isExpanded: !this.state.isExpanded });
  };

  renderMenuItemChildren = option => {
    if (option.isSuspended) {
      return (
        <span className="text-danger font-weight-bold">{option.label}</span>
      );
    }
    return <span>{option.label}</span>;
  };

  renderCollapsed = () => {
    const selectedOption =
      this.state.selected && this.state.selected.length
        ? this.state.selected[0]
        : null;
    const displayValue = selectedOption ? selectedOption.label : "---";

    return (
      <div
        onClick={this.toggleExpanded}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 10px",
          backgroundColor: this.props.disabled ? "unset" : "#f5f5f5",
          borderRadius: "4px",
          cursor: this.props.disabled ? "default" : "pointer",
          minHeight: "32px",
          border: this.props.disabled ? "unset" : "1px solid #e0e0e0",
          transition: "all 0.2s ease",
          lineHeight: "19px"
        }}
        onMouseEnter={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#ebebeb";
          }
        }}
        onMouseLeave={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#f5f5f5";
          }
        }}
      >
        <div
          style={{
            color: selectedOption ? "#333" : "#999",
            fontSize: "14px"
          }}
        >
          {this.props.cellFormatter
            ? this.props.cellFormatter(displayValue)
            : displayValue}
        </div>
        {!this.props.disabled && (
          <FontAwesomeIcon
            icon={faEdit}
            color="#999"
            style={{
              marginLeft: "8px",
              marginBottom: "4px",
              flexShrink: 0,
              fontSize: "12px"
            }}
          />
        )}
      </div>
    );
  };

  render() {
    if (this.props.hidden) {
      return null;
    }

    const isExpanded = this.props.rowExpanded || this.state.isExpanded;
    const id = `${this.props.formKey || ""}-${this.props.name}`;
    const content = (
      <FormGroup className={s.formGroup}>
        <Label
          hidden={!this.props.label || this.props.onTable}
          className={s.label}
          for={id}
        >
          {this.props.label}:
        </Label>
        <div className={`${s.inputGroup}`}>
          <Typeahead
            id={id}
            promptText={this.props.promptText || this.props.label || ""}
            emptyLabel={this.props.emptyLabel || "Sin coincidencias"}
            selected={this.state.selected}
            bsSize={"sm"}
            onChange={this.onChange}
            disabled={this.props.disabled || this.props.isLoading}
            maxResults={this.props.maxResults || 20}
            options={this.state.options}
            className={`${s.errClass} ${s.swinput}`}
            renderMenuItemChildren={this.renderMenuItemChildren}
          />
          {this.props.isLoading && (
            <div className={`${s.prepend}`}>
              <FontAwesomeIcon
                icon={faSpinner}
                pulse
                style={{ fontSize: "18px", color: "#777" }}
              />
            </div>
          )}
        </div>
        {!!this.props.message && (
          <span className={`${s.errorSpan}`}>{this.props.message}</span>
        )}
      </FormGroup>
    );

    if (this.props.onTable) {
      if (this.props.cellCollapsed && !isExpanded) {
        return (
          <td className={this.props.classCol || ""}>
            {this.renderCollapsed()}
          </td>
        );
      }
      return <td className={this.props.classCol || ""}>{content}</td>;
    }

    return <div className={this.btsClassName()}>{content}</div>;
  }
}
